export const environment = {
  production: false,
  environment_name: 'qa',
  client_id: 'addeb4a7-5f61-4387-b1b8-6ecd580aac1b',
  tenant_autority:
    'https://login.microsoftonline.com/' +
    '548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
  redirect_url: 'https://planopro-uat.ko.com/auth-response',
  api_base_url: 'https://aswa-tccc-pib-qa-pyth-backend.azurewebsites.net/',
  app_url: 'https://planopro-uat.ko.com',
  domain_name: '',
  picturesAccount: 'storageinswa01us2uat',
  picturesContainer: 'planopro-qa',
};
